/* eslint-disable react/no-unescaped-entities */
import React, { useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { loaderActions } from '../../../../features/Loader/LoaderSlice';
import ExportWarehousePOs from './Components/ExportWarehousePOs';
import ExportSupplierPOs from './Components/ExportSupplierPOs';
import API from '../../../../Services/API';

function Export() {
  const dispatch = useDispatch();
  const [vendors, setVendors] = React.useState([]);

  async function loadVendors() {
    await dispatch(loaderActions.show());

    const select = ['vendName', 'vendNo', 'VendorType', 'vpFreightType'];
    const EmmaVendorParams = {
      company_id: process.env.REACT_APP_COMP_EMM,
      $filter: 'enableVendorPortal eq true',
      $select: select.join(',')
    };

    const vendorEmma = await API().get(`/vendor_list`, { params: EmmaVendorParams });
    let vendorsResp = vendorEmma.data.value;

    const DunVendorParams = {
      company_id: process.env.REACT_APP_COMP_DUN,
      $filter: 'enableVendorPortal eq true',
      $select: select.join(',')
    };

    API()
      .get(`/vendor_list`, { params: DunVendorParams })
      .then((vendorDun) => {
        vendorsResp = vendorsResp.concat(vendorDun.data.value);
      })
      .finally(() => {
        setVendors(() => vendorsResp);
        dispatch(loaderActions.hide());
      });
  }

  useEffect(() => {
    loadVendors();
  }, []);

  return (
    <>
      <Row>
        <Col className="py-4">
          <ExportSupplierPOs
            vendors={vendors.filter(
              (v) => v.VendorType === 'Hybrid' || v.VendorType === 'Supplier'
            )}
          />
        </Col>
      </Row>
      <Row>
        <Col className="py-4">
          <ExportWarehousePOs
            vendors={vendors.filter(
              (v) => v.VendorType === 'Hybrid' || v.VendorType === 'Warehouse'
            )}
          />
        </Col>
      </Row>
    </>
  );
}

export default Export;
